<template>
	<div v-if="isCameraOpen" class="popup-take-photo">
      
      <div v-show="isCameraOpen && isLoading" class="dot-loading">
        <ul class="loader-circle">
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>

      <div v-show="!isTaken" class="take-photo">
        <video ref="camera" :width="1280" :height="720" autoplay playsinline></video>
        <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
          <button type="button" class="button" @click="takePhoto">
            <img src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png">
          </button>
        </div>
      </div>

      <canvas id="user-photo" ref="canvas" :width="375" :height="375"></canvas>
      <canvas id="photo-adjust" ref="adjust" width="375" height="375"></canvas>
      
    </div>
</template>
<script>
  import { fabric } from 'fabric';
  
  export default {
    name: 'take-picture',
    data() {
      return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        isTaken: false,
        isShotPhoto: false,
        isLoading: false,
        isCameraOpen: false,
        vidW : 0,
        vidH : 0,
        canvasSquare : 0,
        canvasFab : {width:0,height:0},
        constraints : { 
          video: {
            width: {
              ideal: 4096
            },
            height: {
              ideal: 4096
            },
            facingMode: ""
          },
          audio: false
        },
      }
    },
    props: [],
    methods:{
        ResizeCanvases() {
            var cvs = document.getElementsByTagName("canvas");
            for (var c = 0; c < cvs.length; c++) {
              cvs[c].height = this.canvasSquare;
              cvs[c].width = this.canvasSquare;
            }
            this.canvasFab.width = this.canvasSquare;
            this.canvasFab.height = this.canvasSquare;
        },
        toggleCamera(current_take){
            if(current_take.category == "selfie"){
                this.constraints.video.facingMode = "user";
            }
            else{
                this.constraints.video.facingMode = "environment";
            }

            if(this.isCameraOpen) {
                this.isCameraOpen = false;
                this.isTaken = false;
                this.isShotPhoto = false;
                this.stopCameraStream();
            } else {
                this.isCameraOpen = true;
                this.createCameraElement();
            }
        },
        createCameraElement() {
        this.isLoading = true;

        navigator.mediaDevices
          .getUserMedia(this.constraints)
          .then(stream => {
            let track = stream.getTracks()[0];
            if (track.getSettings) {
              let {
                width,
                height
              } = track.getSettings();
              this.vidW = width;
              this.vidH = height;

              // let debug = "camera resolution : "+width+"x"+height;
              
              this.canvasSquare = (this.vidW > this.vidH) ? this.vidH : this.vidW;
              this.$refs.camera.width = (this.vidW > this.vidH) ? this.vidW : this.vidH;
              this.$refs.camera.height = (this.vidH > this.vidW) ? this.vidH : this.vidW;
              // debug += ", set canvas square to : "+this.canvasSquare;
              // alert(debug);

              this.ResizeCanvases();
            }
            this.isLoading = false;
            this.$refs.camera.srcObject = stream;
          })
          .catch(error => {
            this.isLoading = false;
            alert("May the browser didn't support or there is some errors.");
          });
      },
      
      stopCameraStream() {
        let tracks = this.$refs.camera.srcObject.getTracks();

        tracks.forEach(track => {
          track.stop();
        });
      },
      
      takePhoto() {
        if(!this.isTaken) {
          this.isShotPhoto = true;

          const FLASH_TIMEOUT = 50;

          setTimeout(() => {
            this.isShotPhoto = false;
          }, FLASH_TIMEOUT);
        }
        
        this.isTaken = !this.isTaken;

        // var landscape = this.vidW > this.vidH; //Is the video in landscape?
        
        const landscape = !window.matchMedia("(orientation: portrait)").matches;

        var boxSize = this.canvasSquare;
        var ratio = landscape ? this.vidW / this.vidH : this.vidH / this.vidW;
        // var offset = ((boxSize * ratio) - boxSize) / 2;
        
        const canvas = this.$refs.canvas;
        var offset = (this.vidW-canvas.width)/2;
        // let console = "is landscape : "+landscape;
        // console+=", offset : "+offset;
        // console+=", canvas width : "+canvas.width+" height : "+canvas.height;
        // alert(console);
        
        canvas.getContext("2d").drawImage(this.$refs.camera, landscape ? offset : 0, landscape ? 0 : offset, this.canvasSquare, this.canvasSquare, 0, 0, canvas.width, canvas.height);


        const dataURL = canvas.toDataURL("image/jpeg");
        // .replace("image/jpeg", "image/octet-stream")
        
        this.$emit('take-photo',dataURL);
        this.toggleCamera('');

      },
    },
    mounted(){
      this.canvasFab = new fabric.Canvas('photo-adjust', {});
    }
  };
</script>
